import React, { useState, useEffect } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

function InspireMeAttributeCheckboxList({ items, onChange }) {
    const [checkedItems, setCheckedItems] = useState({});

    useEffect(() => {
        if (items) {
            const initialCheckedState = items.reduce((acc, item) => {
                acc[item.id] = false; // Initialize all items as unchecked by default
                return acc;
            }, {});
            setCheckedItems(initialCheckedState);
        }
    }, [items]); // Depend on items so this effect runs whenever items change

    const handleCheckboxChange = (event, id) => {
        setCheckedItems(prev => ({
            ...prev,
            [id]: event.target.checked
        }));
    };

    useEffect(() => {
        if (items) {
            onChange(Object.keys(checkedItems).filter(key => checkedItems[key]));
        }
    }, [checkedItems]);

    return (
        <FormGroup>
            <div className="refiner-heading">Inspire Me Attributes</div>
            {items && items.length > 0 ? items.map((item) => (
                <FormControlLabel
                    key={item.attributeId}
                    control={<Checkbox checked={checkedItems[item.attributeId] ?? false} onChange={(event) => handleCheckboxChange(event, item.attributeId)} />}
                    label={item.attributeName}
                />
            )) : <div>No items to display.</div>}
        </FormGroup>
    );
}

export default InspireMeAttributeCheckboxList;
